import { useCallback } from 'react';
import { SetURLSearchParams, useSearchParams } from 'react-router-dom';
import { LocationState } from 'src/actuators/LocationState.ts';
import { initLocationState, isLocationState } from 'src/actuators/locationStateContext.ts';
import { readSearchParam } from 'src/common/readSearchParam.ts';
import { LOCATION_STORE_PARAM_NAME } from 'src/common/constants.ts';
import { updatedLocationState } from 'src/common/updatedLocationState.ts';

export const useLocationState = (): [
    LocationState,
    (state: LocationState) => URLSearchParams,
    URLSearchParams,
    SetURLSearchParams,
] => {
    const [searchParams, setSearchParams] = useSearchParams();
    const locationState = readSearchParam(
        searchParams,
        LOCATION_STORE_PARAM_NAME,
        { ...initLocationState },
        isLocationState,
    );
    const setState = useCallback((newState: LocationState): URLSearchParams => {
        setSearchParams(updatedLocationState(searchParams, newState), { replace: true });
        return searchParams;
    }, [searchParams, setSearchParams]);
    return [locationState, setState, searchParams, setSearchParams];
};
